import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import _ from 'lodash';
import { Form } from 'semantic-ui-react';
import { match, P } from 'ts-pattern';
import CheckboxField from '../../../formFields/checkboxField';
import StandardFieldLabel from '../../../formFields/formFieldWrapper/standardFieldLabel';
const toSnakeCase = (input) => {
    if (typeof input === 'string')
        return _.snakeCase(input);
    if (Array.isArray(input))
        return _.snakeCase(input.join(' '));
    return 'none';
};
const isSubset = (a, b) => {
    return _.difference(b, a).length === 0;
};
const MultiSelect = ({ definition, value, elmId, onChange, }) => {
    const [selectedValues, setSelectedValues] = useState(_.isNil(value) ? [] : value);
    useEffect(() => {
        setSelectedValues(_.isNil(value) ? [] : value);
    }, [value]);
    const onChangeSelection = (e, definition, value, checked) => {
        let newValues = [];
        if (Array.isArray(value)) {
            const currentValues = selectedValues;
            if (checked) {
                newValues = _.uniq([...currentValues, ...value]);
            }
            else {
                newValues = currentValues.filter(v => !value.includes(v));
            }
        }
        else if (typeof value === 'string') {
            if (checked) {
                newValues = _.uniq([...(selectedValues || []), value]);
            }
            else {
                if (selectedValues?.length) {
                    newValues = selectedValues.filter(v => v !== value);
                }
                else {
                    newValues = selectedValues;
                }
            }
        }
        setSelectedValues(newValues);
        onChange(definition.name, newValues);
        e.currentTarget.querySelector('input')?.focus();
    };
    const contains = (value, optionValue) => {
        return (match(definition.controlValueType)
            .with(P.when(v => v === 'string[]' &&
            Array.isArray(value) &&
            Array.isArray(optionValue)), () => isSubset(value, optionValue))
            .otherwise(() => {
            return _.isNil(value) ? false : value.includes(optionValue);
        }));
    };
    return (_jsx(Form, { style: { marginTop: 6 }, children: definition.options.map((option, index) => (_jsx(CheckboxField, { compact: false, label: _jsx(StandardFieldLabel, { elmId: `${elmId}_${toSnakeCase(option.value)}_label`, label: option.label, subLabel: option.description || '' }), elmId: `${elmId}_${toSnakeCase(option.value)}`, name: '', value: option.value, role: 'info', helpContent: option.tooltip, checked: contains(value, option.value), onChange: (e, data) => {
                onChangeSelection(e, definition, data.value, data.checked);
            }, valueAsArray: definition.controlValueType === 'string[]', tabIndex: index }, index))) }));
};
export default MultiSelect;
//# sourceMappingURL=multiSelect.js.map